import { OperatorFunction, pairwise, startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { ELoadStatus } from '../../state/state.interface';

export function operationsToLoadStatus(): OperatorFunction<symbol[], ELoadStatus> {
  return (source$) =>
    source$.pipe(
      pairwise(),
      map(([prev, curr]) => (prev.length >= 1 && curr.length === 0 ? ELoadStatus.success : ELoadStatus.loading)),
      startWith(ELoadStatus.initial),
    );
}
